/**
 * Strain calculation rules.
 * See: COMBAT.md for Strain and Strain Damage definitions.
 */
export const calculateStrainDamage = (strain: number): number =>
  Math.floor(strain / 2);
